import script from "./AnnounceDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnounceDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./AnnounceDetailView.vue?vue&type=style&index=0&id=3d4a8aa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4a8aa6"]])

export default __exports__